import React, { memo } from 'react';
import { TableCell } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import COMMON from 'constants/common';
import { getStationName } from 'utils/common.helper';
import { StationResponseType } from 'types/maintenance/StationType';
import ListCheckBox from '../../../../system/atoms/checkBoxs/ListCheckBox';
import TooltipComponent from '../../../../system/organisms/dialogs/TooltipComponent';

interface StationGiftTableCellType {
  row: Array<StationResponseType>;
  handleClickCheckBox: (machineNo: string, stationId: number | null) => void;
}

/* ************ Style ************ */
const useStyles = makeStyles()(() => ({
  tdStation: {
    textAlign: 'left',
  },
  tdNoPadding: {
    padding: '0 !important',
  },
  tdStationContentFirst: {
    borderBottom: '1px solid #000',
  },
  tdStationContent: {
    display: 'flex',
    flexDirection: 'row',
    padding: '0 8px',
    height: 58,
  },
  stationRowName: {
    flex: 1,
    width: '484px',
    paddingRight: 8,
    fontSize: '16px',
    paddingTop: 5,
    paddingBottom: 5,
    lineHeight: '25px',
  },
}));

const StationGiftTableCell: React.FC<React.PropsWithChildren<StationGiftTableCellType>> = React.memo(({ row, handleClickCheckBox }) => {
  const { classes } = useStyles();

  return (
    <TableCell className={`${classes.tdStation} ${classes.tdNoPadding}`}>
      {row[0].machineType === COMMON.MACHINE_TYPE.CLENA3 || row[0].machineType === COMMON.MACHINE_TYPE.MULTI || row[0].machineType === COMMON.MACHINE_TYPE.DUO ? (
        <>
          {row.map((item, index) =>
            item ? (
              <div
                key={item.stationId}
                className={
                  (row[0].machineType === COMMON.MACHINE_TYPE.CLENA3 || row[0].machineType === COMMON.MACHINE_TYPE.DUO)
                    ? `${classes.tdStationContent} ${index !== 1 ? classes.tdStationContentFirst : ''}`
                    : `${classes.tdStationContent} ${index !== 3 ? classes.tdStationContentFirst : ''}`
                }>
                <ListCheckBox
                  checked={item.selected ?? false}
                  name="selectStation"
                  onChange={() => handleClickCheckBox(item.boardSerial, item.stationId)}
                />
                <div className={classes.stationRowName}>
                  <TooltipComponent
                    tooltipText={item.giftName}
                    displayWord={getStationName(item.machineType, item.stationName, item.leftRight, item.position)}
                  />
                  <TooltipComponent tooltipText={item.giftName} displayWord={`${item.giftName ?? COMMON.BLANK}`} />
                </div>
              </div>
            ) : null,
          )}
        </>
      ) : (
        <div className={classes.tdStationContent}>
          <ListCheckBox
            checked={row[0].selected ?? false}
            name="selectStation"
            onChange={() => handleClickCheckBox(row[0].boardSerial, row[0].stationId)}
          />
          <div className={classes.stationRowName}>
            <TooltipComponent tooltipText={row[0].giftName} displayWord={`${row[0].stationName ?? COMMON.BLANK}`} />
            <TooltipComponent tooltipText={row[0].giftName} displayWord={`${row[0].giftName ?? COMMON.BLANK}`} />
          </div>
        </div>
      )}
    </TableCell>
  );
});

export default memo(StationGiftTableCell);
